module.exports = __webpack_public_path__ + "static/media/SCR-A-007.610ad67c.mp3";